module.exports = __webpack_public_path__ + "img/myposition_ss_알레산드로 델피에로.c446c429.png";